import { addWeightedField, addOrderByField } from './common/services/builders';


const ORDERBY_DESC = 'desc';
const ORDERBY_ASC = 'asc';


let cswipSchemesContentType = [
	addWeightedField('schemeName', 1000),
	addWeightedField('thumbnailDescription', 1000),
	addWeightedField('schemeDescription', 1000),
	addWeightedField('cswipSchemeRequirements[].markup', 1000),
	addWeightedField('cswipSchemeRequirements[].accordionTitle', 1000),
	addWeightedField('cswipSchemeRequirements[].cswipPDFAccordion[].title', 1000),
	addWeightedField('cswipSchemeRequirements[].cswipPDFAccordion[].description', 1000),
	addWeightedField('cswipSchemeRequirements[].cswipPDFAccordion[].description2', 1000)
];

// let insightsContentType = [
// 	addWeightedField('title', 1000),
// 	addWeightedField('summary', 1000),
// 	addWeightedField('heroImage.altText', 1000),
// 	addWeightedField('heroImage.caption', 1000),
// 	addWeightedField('overview', 1000),
// 	addWeightedField('videoPoster.altText', 1000),
// 	addWeightedField('videoPoster.caption', 1000),
// 	addWeightedField('university', 1000),
// 	addWeightedField('heroImage.altText', 1000),
// 	addWeightedField('caption', 1000),
// 	addWeightedField('entryTitle', 1000),
// 	addWeightedField('profileImage', 1000),
// 	addWeightedField('profileImage.altText', 1000),
// 	addWeightedField('profileImage.caption', 1000),
// 	addWeightedField('objectivesTitle', 1000),
// 	addWeightedField('objectives', 1000),
// 	addWeightedField('objectivesImage[].altText', 1000),
// 	addWeightedField('objectivesImage[].caption', 1000),	
// 	addWeightedField('composer[].markup', 1000),
// 	addWeightedField('composer[].image.image.altText', 1000),
// 	addWeightedField('composer[].markupImage2Columns.markup', 1000),
// 	addWeightedField('composer[].markupImage2Columns.image.caption', 1000),
// 	addWeightedField('composer[].markupImage2Columns.image.altText', 1000),
// 	addWeightedField('solutionTitle', 1000),
// 	addWeightedField('solution', 1000),
// 	addWeightedField('solutionImage.altText', 1000),
// 	addWeightedField('solutionImage.caption', 1000),
// 	addWeightedField('conclusionTitle', 1000),
// 	addWeightedField('conclusion', 1000),
// 	addWeightedField('conclusionImage[].altText', 1000),
// 	addWeightedField('conclusionImage[].caption', 1000),
// 	addWeightedField('profile.entryTitle', 1000),
// 	addWeightedField('profileImage.altText', 1000),
// 	addWeightedField('profileImage.caption', 1000),
// 	//addWeightedField('meetTheExperts', 1000),
// 	//addWeightedField('inThisSection', 1000),
// 	addWeightedField('relatedInsightsTitle', 1000),
// 	//addWeightedField('relatedInsights', 1000),
// 	addWeightedField('industry', 1000),// taxonomy
// 	addWeightedField('keywords1', 1000),// taxonomy
// 	addWeightedField('contentCategory', 1000),// taxonomy
// 	addWeightedField('sectionType', 1000),// taxonomy
// 	addWeightedField('university', 1000),// taxonomy NSIRC
// 	addWeightedField('sponsor', 1000),// taxonomy NSIRC

// ];

let allFields = [
	addWeightedField('entryTitle', 100),
	addWeightedField('entryDescription', 50),
	addWeightedField('searchContent', 10),
	addWeightedField('_searchContent', 10),
	addWeightedField('sys.uri', 5),
	addWeightedField('sys.metadata.keywords', 200),
	addWeightedField('sys.metadata.importedKeywords', 200),
];


var path = window.location.pathname;
//tests
//path = "/technical-knowledge/faqs#/";
//var path = 	"/technical-knowledge/faqs/home.aspx#/";
//var path = 	"/locations/south-east-asia/faqs/home.aspx#/";




let faqListerContentType = [
	addWeightedField('title', 1000),
	addWeightedField('heroImage.caption', 1000),
	addWeightedField('faqComposer[].markup', 1000),
	addWeightedField('faqComposer[].leadTextBlueBold', 1000),
	addWeightedField('faqComposer[].markupImage2Columns.markup', 1000),
	addWeightedField('faqComposer[].markupImage2Columns.image.caption', 1000),
	addWeightedField('faqComposer[].markupImage2Columns.image.altText', 1000),
	addWeightedField('faqComposer[].h2Anchor', 1000),
];

if (path.includes("/technical-knowledge/faqs"))
{
	faqListerContentType = [
		addWeightedField('title', 1000),
		addWeightedField('heroImage.caption', 1000),
		addWeightedField('searchContent', 1000),
	];

}



export const SETTINGS = {
	search:
	{
		appId: 'search',
		contentTypeId: 'search',
		pageSize: 12,
		weightedFields: allFields,	
			// [
			// addWeightedField('entryTitle', 1500),
			// addWeightedField('entryDescription', 1500),
			// addWeightedField('description', 1500),
			// addWeightedField('sys.metadata.description', 1500),
			// addWeightedField('sys.metadata.keywords', 1500),
			// addWeightedField('sys.metadata.importedKeywords', 1500),
			// addWeightedField('sys.metadata.author', 1500),
			// addWeightedField('summary', 1500),
			// addWeightedField('keywords', 1500),
			// addWeightedField('title', 1500),	 //weldasearch title
			// addWeightedField('abstract', 1500),
			// addWeightedField('subjectHeading', 1500),
			// addWeightedField('searchContent', 1500),
			// addWeightedField('overview', 1500),
			// addWeightedField('conclusion', 1500)
			// ],
		taxonomyFilterPaths: [
			'Search/Media',
			'ContentCategory'
		]
	},
	news:
	{
		appId: 'news',
		contentTypeId: 'pressReleases',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000)	
		],
		taxonomyFilters: [
			'categories',
			'industries'
		],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},
	events:
	{
		appId: 'events',
		contentTypeId: 'events',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 100)	
		],
		taxonomyFilters:[
			'eventType'
		],
		orderBy: [
			addOrderByField('eventDate.from', ORDERBY_ASC),
			addOrderByField('eventDate.to', ORDERBY_DESC),
			addOrderByField('title', ORDERBY_ASC)
		]
	},
	TWIInnovationNetworkEventsAppId:
	{
		appId: 'TWIInnovationNetworkEventsAppId',
		contentTypeId: 'events',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 100)	
		],
		taxonomyFilters:[
			'eventType'
		],
		orderBy: [
			addOrderByField('eventDate.from', ORDERBY_ASC),
			addOrderByField('eventDate.to', ORDERBY_DESC),
			addOrderByField('title', ORDERBY_ASC)
		]
	},
	careers:
	{
		appId: 'careers',
		contentTypeId: 'ciphrVacancies',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000),
			addWeightedField('contractType', 1000),
			addWeightedField('location',1000),
			addWeightedField('employmentType',1000),
			addWeightedField('textDescription',1000)			
			// addWeightedField('reference', 800),
			// addWeightedField('department', 600)	
		],
		taxonomyFilters: [
			// 'locationDivision',
			// 'contractType'
		],
	},
	ourstories:
	{
		appId: 'ourstories',
		contentTypeId: 'ourStories',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000),
			addWeightedField('keywords', 600)	
		],
		taxonomyFilters: [
			'industry'
		],
	},
	insights:
	{
		appId: 'insights',
		contentTypeId: 'insights',
		pageSize: 12,
		weightedFields: allFields,
		taxonomyFilters: [
			'keywords1',
			'industry'
		],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.version.published', ORDERBY_DESC),
		],
	},

	GenericInsightsAppId:
	{
		appId: 'GenericInsightsAppId',
		contentTypeId: 'insights',
		pageSize: 12,
		weightedFields: allFields,
		taxonomyFilters: [
			'keywords1',
			'industry',
			'innovationNetworkTopics',
			'innovationNetworkIndustry'
		],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.version.published', ORDERBY_DESC),
		],
	},

	atoz:
	{
		appId: 'atoz',
		contentTypeId: 'atoz',
		pageSize: 12,
		orderBy: [
			addOrderByField('title', ORDERBY_ASC)
		]
	},
	IMReportsListerAppId:
	{
		appId: 'IMReportsListerAppId',
		contentTypeId: 'genericContentWebpage',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title'),
			addWeightedField('description'),
			addWeightedField('sys.metadata.author'),
			addWeightedField('sys.metadata.pagedate'),
			addWeightedField('searchContent'),
			addWeightedField('sys.metadata.importedKeywords'),
			addWeightedField('sys.uri'),
		],
		orderBy: [
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC),
		]
	},
	IMReportsGridAppId:// appId
	{
		appId: 'IMReportsGridAppId',
		contentTypeId: 'genericContentWebpage',
		pageSize: 9999,
		weightedFields: [
			addWeightedField('title'),
			addWeightedField('description'),
			addWeightedField('sys.metadata.author'),
			addWeightedField('sys.metadata.pagedate'),
			addWeightedField('searchContent'),
			addWeightedField('sys.metadata.importedKeywords'),
			addWeightedField('sys.uri'),
		],
		orderBy: [
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC),
		]
	},
	JIPLister: // appId
	{
		appId: 'JIPLister',
		contentTypeId: 'jips',
		pageSize: 12,
		weightedFields: [
			addWeightedField('projectTitle'),
			addWeightedField('reference'),
			addWeightedField('status'),
			addWeightedField('description'),
			addWeightedField('pdfDownload')
		],
		taxonomyFilters: [
			'industries'
		],
		orderBy: [
			addOrderByField('dateAnnounced', ORDERBY_DESC),
		]
	},
	PublishedPapersLister: // appId
	{
		appId: 'PublishedPapersLister',
		contentTypeId: 'publishedPapers',
		pageSize: 12,
		weightedFields: [
			//contentType
			addWeightedField('title', 1000),
			addWeightedField('authors', 800),
			addWeightedField('conference', 800),
			addWeightedField('journal', 800),
			addWeightedField('book', 800),
			addWeightedField('externalLink', 800),
			//addWeightedField('pdf', 800),
			//addWeightedField('pageDate', 800),
			addWeightedField('publishedPaperAbstract[]', 1000),
			addWeightedField('fixedKeywordList', 800),
			addWeightedField('FixedKeywordList', 800),
			//webpage
			addWeightedField('sys.metadata.author', 800),
			addWeightedField('searchContent', 900)

		],
		orderBy: [
			addOrderByField('pageDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},



	CSWIPSchemesAppId:
	{
		appId: 'CSWIPSchemesAppId',
		contentTypeId: 'cswipSchemes',
		pageSize: 12,
		weightedFields: cswipSchemesContentType,
		orderBy: [
			addOrderByField('displayOrder', ORDERBY_ASC)
		]
	},

	CSWIPSearchAppId:
	{
		appId: 'CSWIPSearchAppId',
		contentTypeId: 'cswipSearch',
		pageSize: 12,
		weightedFields: [
			addWeightedField('schemeName', 5000),
			addWeightedField('schemeDescription', 5000),
			addWeightedField('schemeType', 5000),
			// addWeightedField('cswipSchemeRequirements[].markup', 5000),
			// addWeightedField('cswipSchemeRequirements[].accordionTitle', 5000),
			// addWeightedField('article[].markup', 5000),
			// addWeightedField('article[].quote', 5000),
			addWeightedField('heroImage.caption', 5000),
			addWeightedField('heroImage.altText', 5000),
			addWeightedField('heroVideo.description', 5000),
			addWeightedField('summary', 5000),
			addWeightedField('thumbnailImage.caption', 5000),
			addWeightedField('thumbnailImage.altText', 5000),
			addWeightedField('title', 5000),
			addWeightedField('sys.metadata.description', 5000),	
			addWeightedField('searchContent', 5000),
			addWeightedField('sys.metadata.author',5000),
			addWeightedField('sys.metadata.importedCategories',5000),
			addWeightedField('sys.metadata.importedKeywords',5000),
			addWeightedField('sys.slug',5000),
			addWeightedField('sys.uri',5000),
		]
	},
	CSWIPNewsAppId:
	{
		appId: 'CSWIPNewsAppId',
		contentTypeId: 'pressReleases',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000),
			addWeightedField('searchContent', 1000)
		],
		taxonomyFilters: [
			'categories',
			'industries'
		],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},
	CSWIPInsightsAppId:
	{
		appId: 'CSWIPInsightsAppId',
		contentTypeId: 'insights',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000),
			addWeightedField('keywords', 600),	
			addWeightedField('searchContent', 1000)
		],
		taxonomyFilters: [
			'keywords1',
			'industry' // api name of the Content Type component
		],
		orderBy: [
			addOrderByField('sys.version.published', ORDERBY_DESC),
		],
	},
	TWIInnovationNetworkNewsAppId:
	{
		appId: 'TWIInnovationNetworkNewsAppId',
		contentTypeId: 'pressReleases',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000),
			addWeightedField('searchContent', 1000)
		],
		taxonomyFilters: [
			'categories',
			'industries'
		],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},
	TWIInnovationNetworkSearchAppId:
	{
		appId: 'TWIInnovationNetworkSearchAppId',
		contentTypeId: 'twiinSearch',
		pageSize: 12,
		weightedFields: [
			addWeightedField('heroImage.caption', 5000),
			addWeightedField('heroImage.altText', 5000),
			addWeightedField('heroVideo.description', 5000),
			addWeightedField('summary', 5000),
			addWeightedField('thumbnailImage.caption', 5000),
			addWeightedField('thumbnailImage.altText', 5000),
			addWeightedField('title', 5000),
			addWeightedField('sys.metadata.description', 5000),	
			addWeightedField('searchContent', 5000),
			addWeightedField('sys.metadata.author',5000),
			addWeightedField('sys.metadata.importedCategories',5000),
			addWeightedField('sys.metadata.importedKeywords',5000),
			addWeightedField('sys.slug',5000),
			addWeightedField('sys.uri',5000),
		]
	},
	memberListAppId:
	{
		appId: 'memberListAppId',
		contentTypeId: 'members',
		pageSize: 12,
		weightedFields: [
			addWeightedField('displayName', 1000),
			addWeightedField('memberOrg', 1000),
			addWeightedField('sortCol', 1000),
			addWeightedField('country', 1000),
			addWeightedField('industrySector', 1000),
			addWeightedField('industryGroup', 1000),			
			addWeightedField('searchContent', 1000)
		],
		taxonomyFilters: [
			'industries'
		],
		orderBy: [
			addOrderByField('sortCol', ORDERBY_ASC)
		]
	},
	PublicFundedProjectsListerAppId: // appId
	{
		appId: 'PublicFundedProjectsListerAppId',
		contentTypeId: 'publicFundedProjects',
		pageSize: 12,
		weightedFields: allFields,
		// [
		// 	addWeightedField('acronym'),
		// 	addWeightedField('projectTitle'),
		// 	addWeightedField('status'),
		// 	addWeightedField('description'),
		// 	addWeightedField('website'),
		// 	addWeightedField('fundingBody'),
		// 	addWeightedField('industries'),
		// 	addWeightedField('pdfDownloads'),
		// 	addWeightedField('publication'),
		// 	addWeightedField('keywords')

		// ],
		taxonomyFilters: [
			'industries'
		],
		orderBy: [
			addOrderByField('dateAddedToWebsite', ORDERBY_DESC),
		]
	},
	CoreResearchProgrammeListerAppId: // appId
	{
		appId: 'CoreResearchProgrammeListerAppId',
		contentTypeId: 'genericContentWebpage',
		pageSize: 12,
		weightedFields: [
			//webpage
			addWeightedField('title'),
			addWeightedField('description'),
			addWeightedField('searchContent')

		],
		orderBy: [
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},

	FAQListerAppId: // appId
	{
		appId: 'FAQListerAppId',
		contentTypeId: 'faqs',
		pageSize: 12,
		weightedFields: faqListerContentType,
		taxonomyFilters: [
			'language' //id of taxonomy field in Content Type
		],		
		orderBy: [
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]

	},

	CTLFAQListerAppId: // appId
	{
		appId: 'CTLFAQListerAppId',
		contentTypeId: 'faqs',
		pageSize: 12,
		weightedFields: faqListerContentType,
		taxonomyFilters: [
			'certifications'
		],		
		orderBy: [
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]

	},

	

	TWIDEInsightsAppId:
	{
		appId: 'TWIDEInsightsAppId',
		contentTypeId: 'insights',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000),
			addWeightedField('summary', 1000),
			addWeightedField('overview', 1000),
			addWeightedField('objectivesTitle', 1000),
			addWeightedField('objectives', 1000),
			addWeightedField('solutionTitle', 1000),
			addWeightedField('solution', 1000),
			addWeightedField('conclusionTitle', 1000),
			addWeightedField('conclusion', 1000),
			addWeightedField('profile', 1000),
			addWeightedField('industry', 1000),
			addWeightedField('keywords1', 600),
			addWeightedField('contentCategory', 600),
			addWeightedField('sectionType', 600),
		],
		taxonomyFilters: [
			'keywords1',
			'industry'
		],
		orderBy: [
			addOrderByField('sys.version.published', ORDERBY_DESC),
		],
	},
	JobKnowledgeListerAppId: // appId
	{
		appId: 'JobKnowledgeListerAppId',
		contentTypeId: 'genericContentWebpage',
		pageSize: 12,
		weightedFields: [
			//webpage
			addWeightedField('title'),
			addWeightedField('description'),
			addWeightedField('searchContent'),
			// addWeightedField('sys.metadata.importedKeywords'),
			// addWeightedField('sys.metadata.author'),
			// addWeightedField('sys.metadata.pageDate'),				

		],
		orderBy: [
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},
	NSIRCNewsAppId:
	{
		appId: 'NSIRCNewsAppId',
		contentTypeId: 'pressReleases',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000),
			addWeightedField('searchContent', 1000)
		],
		taxonomyFilters: [
			'sponsors',
			'university'
		],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},
	NSIRCPublicationsAppId:
	{
		appId: 'NSIRCPublicationsAppId',
		contentTypeId: 'pressReleases',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000)	
		],
		taxonomyFilters: [
			'sponsors',
			'university'
		],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},
	NSIRCThesesAppId:
	{
		appId: 'NSIRCThesesAppId',
		contentTypeId: 'pressReleases',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000)	
		],
		taxonomyFilters: [
			'sponsors',
			'university'
		],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},
	NSIRCDissertationsAppId:
	{
		appId: 'NSIRCDissertationsAppId',
		contentTypeId: 'pressReleases',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000)	
		],
		taxonomyFilters: [
			'sponsors',
			'university'
		],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},
	NSIRCStudentProfilesAppId:
	{
		appId: 'NSIRCStudentProfilesAppId',
		contentTypeId: 'pressReleases',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000)	
		],
		taxonomyFilters: [
			'sponsors',
			'university'
		],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},
	NSIRCInsightsAppId:
	{
		appId: 'NSIRCInsightsAppId',
		contentTypeId: 'pressReleases',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000)	
		],
		taxonomyFilters: [
			'sponsors',
			'university'
		],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},
	NSIRCCareersAppId:
	{
		appId: 'NSIRCCareersAppId',
		contentTypeId: 'ciphrVacancies',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000),
			addWeightedField('contractType', 1000),
			addWeightedField('location',1000),
			addWeightedField('employmentType',1000),
			addWeightedField('textDescription',1000)			
		],
		taxonomyFilters: [
			// 'locationDivision',
			// 'contractType'
		],
		// taxonomyFilters: [
		// 	'locationDivision',
		// 	'university',
		// 	'contractType'
		// ],
	},
	NSIRCSearchAppId:
	{
		appId: 'NSIRCSearchAppId',
		contentTypeId: 'search',
		pageSize: 12,
		weightedFields: [
			addWeightedField('entryTitle', 1500),
			addWeightedField('entryDescription', 800),
			addWeightedField('description', 800),
			addWeightedField('sys.metadata.description', 800),
			addWeightedField('summary', 800),	
			addWeightedField('keywords', 800),	
			addWeightedField('title', 900),	 //weldasearch title
			addWeightedField('abstract', 800),	
			addWeightedField('subjectHeading', 800),	
			addWeightedField('searchContent', 600),
			addWeightedField('overview', 800),
			addWeightedField('conclusion', 800)
		]
	},
	OurPeopleAppId:
	{
		appId: 'OurPeopleAppId',
		contentTypeId: 'staffProfiles',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000),
			addWeightedField('title1', 1000),
			addWeightedField('company', 1000),
			addWeightedField('shortProfile', 1000),
			addWeightedField('profile', 1000),
			addWeightedField('email', 1000),
			addWeightedField('telephone', 1000),
			addWeightedField('linkedIn', 1000),
			addWeightedField('twitter', 1000)
		],
		// taxonomyFilters: [
		// 	'sponsors',
		// 	'university'
		// ],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},
	GenericPressReleasesAppId:
	{
		appId: 'GenericPressReleasesAppId',
		contentTypeId: 'pressReleases',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000),
			addWeightedField('searchContent', 1000)
		],
		// taxonomyFilters: [
		// 	'categories',
		// 	'industries'
		// ],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},

	GenericShowcaseAppId:
	{
		appId: 'GenericShowcaseAppId',
		contentTypeId: 'showcase',
		pageSize: 12,
		weightedFields: [
			addWeightedField('title', 1000),
			addWeightedField('videoDescripton', 1000),
			addWeightedField('searchContent', 1000)
		],
		// taxonomyFilters: [
		// 	'categories',
		// 	'industries'
		// ],
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},

	TWICLCompaniesAppId: // appId
	{
		appId: 'TWICLCompaniesAppId',
		contentTypeId: 'registerOfCompanies',
		pageSize: 12,
		weightedFields: [
			addWeightedField('companyName'),
		],		
		orderBy: [
			addOrderByField('companyName', ORDERBY_DESC)
		]

	},

	TWICLCertificationsAppId:
	{
		appId: 'TWICLCertificationsAppId',
		contentTypeId: 'cswipSchemes',
		pageSize: 12,
		weightedFields: cswipSchemesContentType,
		orderBy: [
			addOrderByField('displayOrder', ORDERBY_ASC)
		]
	},

	GenericSearchAppId:
	{
		appId: 'GenericSearchAppId',
		contentTypeId: 'search',
		pageSize: 12,
		weightedFields: allFields,
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC),
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]	
	},

	GenericWebpageListerAppId: // appId
	{
		appId: 'GenericWebpageListerAppId',
		contentTypeId: 'genericContentWebpage',
		pageSize: 12,
		weightedFields: [
			//webpage
			addWeightedField('title'),
			addWeightedField('description'),
			addWeightedField('searchContent')

		],
		orderBy: [
			addOrderByField('sys.metadata.pageDate', ORDERBY_DESC)
		]
	},

	DigitalProductFinderAppId: // appId
	{
		appId: 'DigitalProductFinderAppId',
		contentTypeId: 'DigitalProductFinder',
		pageSize: 12,
		weightedFields: allFields,
		// taxonomyFilters: [
		// 	'language' //id of taxonomy field in Content Type
		// ],		
		orderBy: [
			addOrderByField('skill', ORDERBY_DESC)
		]

	},

	TWIJobsAppId: // appId
	{
		appId: 'TWIJobsAppId',
		contentTypeId: 'twiJobs',
		pageSize: 12,
		weightedFields: allFields,
		// taxonomyFilters: [
		// 	'language' //id of taxonomy field in Content Type
		// ],		
		// orderBy: [
		// 	addOrderByField('skill', ORDERBY_DESC)
		// ]

	},

	TWIJobsDescriptionAppId: // appId
	{
		appId: 'TWIJobsDescriptionAppId',
		contentTypeId: 'twiJobs',
		pageSize: 1,
		weightedFields: allFields,
		// taxonomyFilters: [
		// 	'language' //id of taxonomy field in Content Type
		// ],		
		// orderBy: [
		// 	addOrderByField('skill', ORDERBY_DESC)
		// ]

	},

	TWIInnovationNetworkTAPsAppId: // appId
	{
		appId: 'TWIInnovationNetworkTAPsAppId',
		contentTypeId: 'taps',
		pageSize: 12,
		weightedFields: allFields,
		// taxonomyFilters: [
		// 	'language' //id of taxonomy field in Content Type
		// ],		
		// orderBy: [
		//  	addOrderByField('skill', ORDERBY_DESC)
		// ]

	},

	GenericVideosAppId: // appId
	{
		appId: 'GenericVideosAppId',
		contentTypeId: 'videos',
		pageSize: 12,
		weightedFields: allFields,
		orderBy: [
			addOrderByField('publishDate', ORDERBY_DESC)
		]
	},

	GenericVideoDisplayAppId: // appId
	{
		appId: 'GenericVideoDisplayAppId',
		contentTypeId: 'videos',
		pageSize: 12,
		weightedFields: allFields,
		// orderBy: [
		//  	addOrderByField('publishDate', ORDERBY_DESC)
		// ]
	},

	VirtualAcademyAppId: // appId
	{
		appId: 'VirtualAcademyAppId',
		contentTypeId: 'VirtualAcademy',
		pageSize: 12,
		weightedFields: allFields,
		// orderBy: [
		//  	addOrderByField('publishDate', ORDERBY_DESC)
		// ]
	},

	TesCoursesAppId:
	{
		appId: 'TesCoursesAppId',
		contentTypeId: 'tesCPD',
		pageSize: 12,
		weightedFields: allFields
	},


};
/* End App Config */

/* Start Is Local or Prod */
export const isProd = process.env.NODE_ENV === 'production';
export const apiPrefix = !isProd ? 'https://preview-twi.cloud.contensis.com' : 'https://live-twi.cloud.contensis.com';
//export const apiPrefix = !isProd ? 'https://preview-twi-dev.cloud.contensis.com' : 'https://live-twi-dev.cloud.contensis.com';

/* End Is Local or Prod */

export const SYNONYMS = !isProd ? '/source-files/app/Synonyms.json' : '/site-elements/synonyms/Synonyms.json';

/* Start CMS Config */
export const Configuration = {
	rootUrl: 'https://cms-twi.cloud.contensis.com',
	//rootUrl: 'https://cms-twi-dev.cloud.contensis.com',
	accessToken: 'D8wMky9p2x41vFHrR8MVV3bOWg7UCpolPYQTVMzoySnGJTx5',
	versionStatus: !isProd ? 'latest' : 'published',
	projectId: 'website',
};
/* End CMS Config */